const timestampSorter = (a, b) => a.created_at < b.created_at;

export { timestampSorter}



// WEBPACK FOOTER //
// ./src/utils/Sorters.js